<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('code', ['publicInfo']),
  },
  data() {
    return {
      cookiesData: null,
    };
  },
  render() {
    return this.$scopedSlots.default({
      config: this.cookiesData,
    });
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.cookiesData = {
        version: 2,
        termsLink: 'https://www.rfider.com/terms-of-use',
        policyLink: 'https://haloglide.com/legals/privacy-policy',
        cookieLink: 'https://haloglide.com/legals/cookie-policy',
        urlPrivacyPolicy:
          this.publicInfo &&
          this.publicInfo.info &&
          this.publicInfo.info.urlPrivacyPolicy
            ? this.publicInfo.info.urlPrivacyPolicy
            : '',
        entityName: this.publicInfo ? this.publicInfo.organizationName : '',
      };
    },
  },
};
</script>
